/** Captures device information from the browser environment or returns defaults */
export function captureDeviceInfo() {
    const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
    const platform = typeof navigator !== 'undefined' ? navigator.platform : 'unknown';
    let type = 'web';
    if (/Mobile|Android|iPhone|iPad/i.test(ua)) {
        type = 'mobile';
    }
    else if (!/Mobile|Android|iPhone|iPad/i.test(ua) && typeof window === 'undefined') {
        type = 'desktop';
    }
    let browser = 'unknown';
    let version = 'unknown';
    if (ua.includes('Chrome/')) {
        browser = 'Chrome';
        version = ua.split('Chrome/')[1]?.split(' ')[0] ?? 'unknown';
    }
    else if (ua.includes('Firefox/')) {
        browser = 'Firefox';
        version = ua.split('Firefox/')[1]?.split(' ')[0] ?? 'unknown';
    }
    else if (ua.includes('Safari/') && ua.includes('Version/')) {
        browser = 'Safari';
        version = ua.split('Version/')[1]?.split(' ')[0] ?? 'unknown';
    }
    else if (ua.includes('Edge/')) {
        browser = 'Edge';
        version = ua.split('Edge/')[1]?.split(' ')[0] ?? 'unknown';
    }
    const id = typeof crypto !== 'undefined' && crypto.randomUUID
        ? crypto.randomUUID()
        : `device-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    return { type, id, platform, browser, version };
}
/**
 * Captures geolocation data using the browser Geolocation API.
 * @returns GeoInfo if available and permitted, null otherwise
 */
export function captureGeoTag() {
    return new Promise((resolve) => {
        if (typeof navigator === 'undefined' || !navigator.geolocation) {
            resolve(null);
            return;
        }
        navigator.geolocation.getCurrentPosition((position) => {
            resolve({
                latitude: position.coords.latitude,
                longitude: position.coords.longitude,
                accuracy: position.coords.accuracy,
                timestamp: new Date(position.timestamp).toISOString(),
            });
        }, () => resolve(null), { timeout: 5000, maximumAge: 60000 });
    });
}
/**
 * Captures network connection information.
 * @returns NetworkInfo with connection details or defaults
 */
export function captureNetworkInfo() {
    return new Promise((resolve) => {
        const conn = typeof navigator !== 'undefined'
            ? navigator.connection
            : undefined;
        const connectionType = conn?.effectiveType ?? conn?.type ?? 'unknown';
        resolve({
            ipAddress: '0.0.0.0',
            connectionType,
        });
    });
}
/**
 * Captures full transaction metadata based on provided options.
 * @param options - Which metadata to capture
 * @param userId - The user performing the action
 * @returns TransactionMetadata object
 */
export async function captureMetadata(options, userId) {
    const device = options.captureDevice ? captureDeviceInfo() : { type: 'web', id: 'unknown', platform: 'unknown' };
    const geo = options.captureGeo ? await captureGeoTag() : undefined;
    const network = options.captureNetwork ? await captureNetworkInfo() : { ipAddress: '0.0.0.0' };
    return {
        timestamp: new Date().toISOString(),
        userId,
        geoTag: geo ? { latitude: geo.latitude, longitude: geo.longitude, accuracy: geo.accuracy } : undefined,
        device,
        network,
        consent: options.consentGiven,
    };
}
//# sourceMappingURL=capture.js.map